import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api/admin-settings`;

export const fetchSettings = (email, password) =>
  axios.get(`${BASE}/app-settings`, { auth: { username: email, password } }).then((r) => r.data);

export const saveSettings = (email, password, data) =>
  axios.put(`${BASE}/app-settings`, data, { auth: { username: email, password } }).then((r) => r.data);

export const fetchAvailableStates = (email, password) =>
  axios.get(`${BASE}/available-states`, { auth: { username: email, password } }).then((r) => r.data);
